const getTrackingCheckpointDecorationStyles = hasDecorativeLine => theme => {
  const commonStyles = {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing()
  };
  const decorativeLineStyles = {
    '::before': {
      position: 'absolute',
      marginLeft: 'auto',
      marginRight: 'auto',
      content: "''",
      height: `calc(100% + ${theme.spacing(5)}px)`,
      width: theme.spacing(0.25),
      backgroundColor: theme.palette.gray.light
    }
  };
  if (hasDecorativeLine) {
    return {
      ...commonStyles,
      ...decorativeLineStyles
    };
  } else {
    return commonStyles;
  }
};

export { getTrackingCheckpointDecorationStyles };
//# sourceMappingURL=TrackingCheckpointDecorationStyles.js.map
